import type {GetListResponse, ParamsOptions} from "@/src/modules/core/types";

import {dispatchLogsApi} from "../api";
import type {DispatchLog} from "../types";

class DispatchLogsService {
  async getDispatchLogs(options: ParamsOptions): Promise<GetListResponse<DispatchLog>> {
    const {data} = await dispatchLogsApi.search(options);
    const raw = data as {data?: DispatchLog[]; dispatch_logs?: DispatchLog[]};
    const items = Array.isArray(raw.data)
      ? raw.data
      : Array.isArray(raw.dispatch_logs)
        ? raw.dispatch_logs
        : (raw.data as unknown as {data?: DispatchLog[]})?.data ?? [];
    const meta = (data as {meta?: {total: number; from?: number; to?: number}}).meta ?? {total: 0};
    return {
      data: items,
      meta: {
        total: meta.total,
        from: meta.from ?? 0,
        to: meta.to ?? 0,
      },
    };
  }

  async getDispatchLog(id: number): Promise<DispatchLog | undefined> {
    const {data} = await dispatchLogsApi.getById(id);
    return data.data;
  }

  async createDispatchLog(payload: Record<string, unknown>): Promise<DispatchLog | undefined> {
    const {data} = await dispatchLogsApi.create(payload);
    return data.data;
  }

  async updateDispatchLog(
    id: number,
    payload: Record<string, unknown>,
  ): Promise<DispatchLog | undefined> {
    const {data} = await dispatchLogsApi.update(id, payload);
    return data.data;
  }

  async deleteDispatchLog(id: number): Promise<void> {
    await dispatchLogsApi.delete(id);
  }

  async getDispatchLogTypes(): Promise<
    {dispatch_log_type_id: number; type: string}[]
  > {
    const {data} = await dispatchLogsApi.getDispatchLogTypes();
    return data.dispatch_log_types ?? [];
  }
}

export const dispatchLogsService = new DispatchLogsService();
